module.exports = __webpack_public_path__ + "img/login-header-194021c25a9ce4af4b56f27d63c70a61.png";